import { useOktaAuth } from '@okta/okta-react';
import { initAnalytics, setDefaultSharedProperties } from '@wmgone/analytics';
import { useContext, useEffect } from 'react';

import { env } from '~/lib/env';
import { useUser } from '~/modules/auth/hooks/useUser';
import { BrandContext } from '~/modules/branding';
import { checkUserForOptOut } from '~/modules/monitoring/analytics/utils/checkUserForOptOut';
import { getAnalyticsProperties } from '~/modules/monitoring/analytics/utils/getAnalyticsProperties';

/**
 * Component used in the Container to initialize the Analytics and  set global
 * analytics user properties.
 */
export function Analytics() {
  const user = useUser();
  const brand = useContext(BrandContext);
  const { authState } = useOktaAuth();

  useEffect(() => {
    // Initialize the analytics module only once we have a fully logged in and
    // authenticated user.
    if (authState?.isAuthenticated) {
      initAnalytics(env('VITE_AMPLITUDE_API_KEY', false));
      checkUserForOptOut(user);

      // Sets the default shared properties both at the User and Event level.
      // NOTE: These properites will identify the user data in the analytics
      //       and will also be included for every call to the base-analytics
      //       trackEvent() method across all applications that are hosted
      //       within the Container.
      setDefaultSharedProperties(getAnalyticsProperties(user, brand));
    }
  }, [authState?.isAuthenticated, brand, user]);

  return null;
}

Analytics.displayName = 'Analytics';
